import axios from 'axios';
import { count } from '../../monitor';

// Since we're adding a retryInterceptor we need to create a new instance of axios so
// This interceptor won't affect other axios calls
export const createAxiosInstance = () => axios.create();

export const retryInterceptor = (axiosInstance) => {

    const retryAndEject = (config) => {
        config.__isRetryRequest = true;
        count('translation.retry');
        return axiosInstance.request(config);
    };

    const responseInterceptor = (response) => {
        const { status, config } = response;
        if (status === 207 && !config.__isRetryRequest) {
            return retryAndEject(config);
        }
        return response;
    };

    const errorInterceptor = (error) => {
        const { response, config } = error;
        if (response?.status === 500 && !config.__isRetryRequest) {
            return retryAndEject(config);
        }
        return Promise.reject(error);
    };

    axiosInstance.interceptors.response.use(responseInterceptor, errorInterceptor);
};
